import * as React from "react";
import type { SVGProps } from "react";
const SvgFrance = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v720H0z"
      style={{
        fill: "#ec2b3a",
      }}
    />
    <path
      d="M0 0h853.33v720H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M0 0h426.67v720H0z"
      style={{
        fill: "#293688",
      }}
    />
  </svg>
);
export default SvgFrance;
